<div class="app-layout" [class.public-layout]="isPublicRoute" [class.secure-layout]="!isPublicRoute">
  <app-nav-menu></app-nav-menu>
  <div class="container app-page-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer-page></app-footer-page>